const table = {
  1: -2.41,
  2: -2.05,
  3: -1.88,
  4: -1.75,
  5: -1.65,
  6: -1.56,
  7: -1.48,
  8: -1.41,
  9: -1.34,
  10: -1.28,
  11: -1.23,
  12: -1.18,
  13: -1.13,
  14: -1.08,
  15: -1.04,
  16: -1,
  17: -0.95,
  18: -0.92,
  19: -0.88,
  20: -0.84,
  21: -0.81,
  22: -0.77,
  23: -0.74,
  24: -0.71,
  25: -0.67,
  26: -0.64,
  27: -0.61,
  28: -0.58,
  29: -0.55,
  30: -0.52,
  31: -0.5,
  32: -0.47,
  33: -0.44,
  34: -0.41,
  35: -0.39,
  36: -0.36,
  37: -0.33,
  38: -0.31,
  39: -0.28,
  40: -0.25,
  41: -0.23,
  42: -0.2,
  43: -0.18,
  44: -0.15,
  45: -0.13,
  46: -0.1,
  47: -0.08,
  48: -0.05,
  49: -0.03,
  50: 0,
  51: 0.03,
  52: 0.05,
  53: 0.08,
  54: 0.1,
  55: 0.13,
  56: 0.15,
  57: 0.18,
  58: 0.2,
  59: 0.23,
  60: 0.25,
  61: 0.28,
  62: 0.31,
  63: 0.33,
  64: 0.36,
  65: 0.39,
  66: 0.41,
  67: 0.44,
  68: 0.47,
  69: 0.5,
  70: 0.52,
  71: 0.55,
  72: 0.58,
  73: 0.61,
  74: 0.64,
  75: 0.67,
  76: 0.71,
  77: 0.74,
  78: 0.77,
  79: 0.81,
  80: 0.84,
  81: 0.88,
  82: 0.92,
  83: 0.95,
  84: 1,
  85: 1.04,
  86: 1.08,
  87: 1.13,
  88: 1.18,
  89: 1.23,
  90: 1.28,
  91: 1.34,
  92: 1.41,
  93: 1.48,
  94: 1.56,
  95: 1.65,
  96: 1.75,
  97: 1.88,
  98: 2.05,
  99: 2.41
}

function receipt (zScore, years) {
  let cls = ''
  let text = ''
  if (typeof (zScore) !== 'undefined') {
    if (years < 5) {
      if (zScore > 3) {
        text = 'Ожирение'
        cls = 'danger'
      } else if (zScore > 2) {
        text = 'Избыточное питание'
        cls = 'attention'
      } else if (zScore > 1) {
        text = 'Риск избыточного питания'
        cls = 'warning'
      } else if (zScore > -1) {
        text = 'Питание в норме'
      } else if (zScore >= -2) {
        text = 'Недостаточность питания лёгкой степени'
        cls = 'warning'
      } else if (zScore >= -3) {
        text = 'Недостаточность питания умеренной степени'
        cls = 'attention'
      } else {
        text = 'Недостаточность питания тяжёлой степени'
        cls = 'danger'
      }
    } else if (years <= 18) {
      if (zScore > 2) {
        text = 'Ожирение'
        cls = 'danger'
      } else if (zScore > 1) {
        text = 'Избыточное питание'
        cls = 'attention'
      } else if (zScore > -1) {
        text = 'Питание в норме'
      } else if (zScore >= -2) {
        text = 'Недостаточность питания лёгкой степени'
        cls = 'warning'
      } else if (zScore >= -3) {
        text = 'Недостаточность питания умеренной степени'
        cls = 'attention'
      } else {
        text = 'Недостаточность питания тяжёлой степени'
        cls = 'danger'
      }
    }
  }
  return {
    text,
    cls
  }
}

function receiptStature (zScore, years) {
  let cls = ''
  let text = ''
  if (typeof (zScore) !== 'undefined') {
    if (zScore > 3) {
      text = 'Очень высокий рост (гигантизм)'
      cls = 'danger'
    } else if (zScore > 2) {
      text = 'Высокий рост'
      cls = 'attention'
    } else if (zScore > -2) {
      text = 'Нормальный рост'
    } else if (zScore >= -3) {
      text = 'Низкий рост'
      cls = 'attention'
    } else {
      text = 'Очень низкий рост (нанизм)'
      cls = 'danger'
    }
  }
  return {
    text,
    cls
  }
}

export default {
  calc (percent, years, type = 'bmi') {
    let zScore
    let keys = Object.keys(table)
    for (let i = 0; i < keys.length; i++) {
      const key = parseInt(keys[i])
      if (percent <= key || (i === keys.length - 1)) {
        if (i > 0) {
          const prevKey = parseInt(keys[i - 1])
          // (yp - y1)/(xp - x1) = (y2 - y1)/(x2 - x1)
          // yp = k* (xp - x1) + y1
          const y2 = table[key]
          const y1 = table[prevKey]
          const k = (y2 - y1) / (key - prevKey)
          zScore = k * (percent - prevKey) + y1
        } else {
          const nextKey = parseInt(keys[i + 1])
          const y2 = table[nextKey]
          const y1 = table[key]
          const k = (y2 - y1) / (nextKey - key)
          zScore = k * (percent - key) + y1
        }
        break
      }
    }
    zScore = parseInt(zScore * 100) / 100

    let ret
    if (type === 'bmi') {
      ret = receipt(zScore, years)
    } else if (type === 'stature') {
      ret = receiptStature(zScore, years)
    }
    ret.value = zScore
    return ret
  }
}
